import React from "react";

import cx from "classnames";

import ArrowDropdown, { DropdownItem } from "~/ui/ArrowDropdown";

import type { ObjectiveStatus } from "~/__generated__/ObjectiveQuery_Info.graphql";

import styles from "./StatusInput.module.css";

export const StatusNames = {
	NO_STATUS: "No status",
	AT_RISK: "At Risk",
	ON_TRACK: "On Track",
	COMPLETED: "Completed",
	ABANDONED: "Postponed",
	BEHIND: "Behind",
} as const;

const StatusClasses = {
	NO_STATUS: styles.statusGrey,
	AT_RISK: styles.statusRed,
	ON_TRACK: styles.statusGreen,
	COMPLETED: styles.statusGreen,
	ABANDONED: styles.statusGrey,
	BEHIND: styles.statusRed,
};

interface StatusInputProps {
	selected: ObjectiveStatus;
	onChange: (status: ObjectiveStatus) => void;
	className?: string;
}

export default function StatusInput({ selected, onChange, className }: StatusInputProps) {
	const handleChange = React.useCallback(
		(status: ObjectiveStatus) => () => {
			onChange(status);
		},
		[onChange],
	);

	return (
		<ArrowDropdown
			hideArrow
			heading="Select status"
			text={<span className={cx(styles.statusBadge, StatusClasses[selected])}>{StatusNames[selected]}</span>}
			textClassName={styles.statusBadge}
			popupClassName={styles.popup}
			className={className}
		>
			{Object.keys(StatusNames).map(status => (
				<DropdownItem key={`status-${status}`} onClick={handleChange(status as ObjectiveStatus)}>
					<span className={cx(styles.statusBadge, StatusClasses[status as ObjectiveStatus])}>
						{StatusNames[status as ObjectiveStatus]}
					</span>
				</DropdownItem>
			))}
		</ArrowDropdown>
	);
}
